import { usePunditUserContext } from "@/react/contexts";
import { isCommunityAdmin } from "../helpers/communityMemberHelpers";

export const useIsConnectEnabled = () => {
  const { currentCommunity, currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();

  const isConnectEnabled = Boolean(currentCommunity?.connect_enabled);
  const isConnectAdminOnly = Boolean(
    currentCommunitySettings?.connect_admin_only,
  );
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  if (isConnectAdminOnly) {
    return isAdmin && isConnectEnabled;
  }

  return isConnectEnabled;
};
